import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import usePerfil from "components/hooks/usePerfil";
import { ETipoUsuario } from "domain/types";
import { useLoggerContext } from "contexts/logger/logger.context";
import loadable from "@loadable/component";

const ClienteFinalRoutes = loadable(
  () => import("components/app/clienteFinal/Routes.js"),
);
const AgencieroRoutes = loadable(
  () => import("components/app/agenciero/Routes.js"),
);
const InternoRoutes = loadable(
  () => import("components/app/interno/Routes.js"),
);
const ProductorRoutes = loadable(
  () => import("components/app/productor/Routes.js"),
);
const GestorRoutes = loadable(() => import("components/app/gestor/Routes.js"));
const VendedorRoutes = loadable(
  () => import("components/app/vendedor/Routes.js"),
);
const SupervisorRoutes = loadable(
  () => import("components/app/supervisor/Routes.js"),
);

const RUTAS_POR_PERFIL = {
  [ETipoUsuario.ClienteFinal]: ClienteFinalRoutes,
  [ETipoUsuario.Agenciero]: AgencieroRoutes,
  [ETipoUsuario.Interno]: InternoRoutes,
  [ETipoUsuario.Productor]: ProductorRoutes,
  [ETipoUsuario.Gestor]: GestorRoutes,
  [ETipoUsuario.Vendedor]: VendedorRoutes,
  [ETipoUsuario.Supervisor]: SupervisorRoutes,
};

const useReduxSelector = () =>
  useSelector((state) => ({
    isOnNativeApp: state.nativeMessagesReducer.isOnNativeApp,
    deepLinkData: state.nativeMessagesReducer.deepLinkData,
  }));

const Routes = () => {
  const { tipoUsuario } = usePerfil();
  const { logger } = useLoggerContext();
  const navigate = useNavigate();
  const { isOnNativeApp, deepLinkData } = useReduxSelector();

  useEffect(() => {
    if (!isOnNativeApp || !deepLinkData) return;

    const deepLink = JSON.parse(deepLinkData);
    if (deepLink.$deeplink_path) navigate(deepLink.$deeplink_path);
  }, [isOnNativeApp, deepLinkData, navigate]);

  const RutasDelPerfil = tipoUsuario
    ? RUTAS_POR_PERFIL[tipoUsuario]
    : undefined;

  useEffect(() => {
    if (RutasDelPerfil) return;

    logger.error(
      `[${Routes.name}] - No route tree for the current userType. Rendering nothing...`,
      { tipoUsuario },
    );
  }, [RutasDelPerfil, tipoUsuario, logger]);

  return RutasDelPerfil ? <RutasDelPerfil /> : null;
};

export default Routes;
